// Whether a school's last analytics read carried the time-saved block
// (COF-591), so a loading skeleton draws the time-saved boxes only when the
// loaded page will have them. The block sits behind a switch; a skeleton that
// always drew them would make every school's page shift on load while it is
// off. Storage is a convenience: when it is missing or blocked the hint reads
// "no", which draws nothing that could vanish.

const keyFor = (school) => { return `timeSavedHint:${school}`; };

/** @param {string} school - the portal slug, or the institution id in the console */
export const readTimeSavedHint = (school) => {
  if (!school) { return false; }
  try {
    return window.localStorage.getItem(keyFor(school)) === '1';
  } catch (err) {
    return false;
  }
};

/** Record whether the analytics envelope just read carried `timeSaved`. */
export const writeTimeSavedHint = (school, present) => {
  if (!school) { return; }
  try {
    window.localStorage.setItem(keyFor(school), present ? '1' : '0');
  } catch (err) {
    // Without storage the next skeleton draws no time-saved boxes.
  }
};
